
import { Component, Vue } from "vue-property-decorator";
import VisualConf from "./components/VisualConf.vue";
import { VisualConfModel } from "./generator/visual/VisualConfModel";
import { defaultVisualConf } from "./service/ConfigurationService";
import { FieldEditorModel } from "./components/FieldEditorModel";
import { initialFieldEditorValue, fieldToModel } from "./components/EditorTool";
import { generateVisual } from "./generator/visual/VisualGenerator";
import { generateTextual } from "./generator/textual/TextualGenerator";
import RootEditor from "./components/RootEditor.vue";
import { FieldModel } from "./model/field";
import { toVersionOneOne } from "./service/SvgUtil";

@Component({
  components: {
    VisualConf,
    RootEditor,
  },
})
export default class App extends Vue {
  visualConf: VisualConfModel = defaultVisualConf();
  editorModel: FieldEditorModel | "loading" = "loading";
  textual = "Loading...";
  visual = "<p>Loading...</p>";

  async mounted(): Promise<void> {
    this.editorModel = await initialFieldEditorValue();
    this.updateModel();
  }

  async updateModel(): Promise<void> {
    if (this.editorModel != "loading") {
      const model: FieldModel = fieldToModel(this.editorModel);
      const textual = await generateTextual(model);
      const visual = await generateVisual(model, this.visualConf);

      this.textual = textual;
      this.visual = visual;
    }
  }

  async updateVisual(): Promise<void> {
    if (this.editorModel != "loading") {
      const model: FieldModel = fieldToModel(this.editorModel);
      this.visual = await generateVisual(model, this.visualConf);
    }
  }

  download(): void {
    const data = toVersionOneOne(this.visual);
    const element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:image/svg+xml;charset=utf-8," + encodeURIComponent(data)
    );
    element.setAttribute("download", "test.svg");

    element.style.display = "none";
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
  }
}
